import { NB } from '@cerebral-inc/ui';
import parse from 'html-react-parser';
import { getStaticFilePath } from 'components/shared/utils';
import Check from './images/check.svg';

const { Flex, Text, Image } = NB;

export interface CheckItemProps {
  title: string;
  description: string;
}

const CheckItem = ({ title, description }: CheckItemProps) => {
  return (
    <Flex flexDir="row" py="20px">
      <Flex
        w="20px"
        h="20px"
        borderRadius="50%"
        backgroundColor="#ECEAFF"
        justifyContent="center"
        alignItems="center"
        mr="16px"
      >
        <Image
          src={getStaticFilePath(Check)}
          width="16px"
          height="16px"
          alt="icon-check"
        />
      </Flex>
      <Flex w="calc(100% - 36px)">
        <Text
          color="#1C1E21"
          fontSize="18px"
          fontWeight={600}
          lineHeight="24px"
          fontFamily="Poppins"
        >
          {parse(title)}
        </Text>
        <Text
          color="#353A41"
          fontSize="14px"
          lineHeight="24px"
          mt="8px"
          fontFamily="Poppins"
        >
          {parse(description)}
        </Text>
      </Flex>
    </Flex>
  );
};

export default CheckItem;
